var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNdPlanBasicWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.88281C2.99823 6.59956 3.07366 6.32099 3.21777 6.07715L3.21875 6.07422C3.36177 5.82859 3.56624 5.624 3.81152 5.48047L9.23926 2.37891C9.49038 2.23801 9.77355 2.16407 10.0615 2.16406C10.3495 2.16406 10.6327 2.23802 10.8838 2.37891L16.3076 5.47754V5.47852C16.4927 5.58674 16.6549 5.72886 16.7852 5.89746L16.9043 6.0752C17.0109 6.26052 17.0801 6.46422 17.1084 6.6748L17.123 6.8877V13.0928L17.1084 13.3076C17.0801 13.5207 17.0103 13.7267 16.9023 13.9141V13.916C16.7618 14.1618 16.5573 14.3653 16.3115 14.5059L10.8809 17.6094L10.8779 17.6113C10.63 17.7552 10.3481 17.8311 10.0615 17.8311C9.77494 17.831 9.49301 17.7551 9.24512 17.6113L9.24316 17.6094L3.81152 14.5059C3.56495 14.3622 3.36014 14.1565 3.21777 13.9092C3.07502 13.6611 2.99992 13.3799 3 13.0938V6.88281Z",
    fill: "#FFFFFF",
    stroke: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdPlanBasicWhite);
export default __webpack_public_path__ + "static/media/nd-plan-basic-white.4dbae13fc084520d9b34633761eb6044.svg";
export { ForwardRef as ReactComponent };